import React from "react";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/Popover";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as List from "../../../../../../../common-deprecated/styles/v2/toyota/globals/List";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { buyCar } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import Container from "../../common/styles/Container";
import useBuy from "../../../../hooks/buy/useBuy";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { MODAL_BUY_TERMS } from "../../../../utils/modalConstants";
import DisclaimerContainer from "../../common/disclaimer/DisclaimerContainer";
import PaymentPanel from "./PaymentPanel";
import * as Styles from "./styles/Buy";
import FinanceQuotes from "../../common/FinanceQuotes";
import { trackCtaCheckout } from "../../../../utils/tracking";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

export const getBuyIcon = (iconType: string): JSX.Element | null => {
    switch (iconType) {
        case "location":
            return (
                <IconWrapper>
                    <Icon variant="location" />
                </IconWrapper>
            );
        case "car":
            return (
                <IconWrapper size="xl">
                    <Icon variant="car" />
                </IconWrapper>
            );
        case "lock":
            return (
                <IconWrapper size="xl">
                    <Icon variant="lock" />
                </IconWrapper>
            );
        case "file-alt":
            return (
                <IconWrapper>
                    <Icon variant="pointCheck" />
                </IconWrapper>
            );
        case "user":
            return (
                <IconWrapper size="xl">
                    <Icon variant="profile" />
                </IconWrapper>
            );
        case "price-alt":
            return (
                <IconWrapper>
                    <Icon variant="card" />
                </IconWrapper>
            );
        case "ok":
            return (
                <IconWrapper>
                    <Icon variant="like" />
                </IconWrapper>
            );
        default:
            return null;
    }
};

const BuyView = (): JSX.Element => {
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const { labels, enableTermsConditions } = useBuy();
    const quoteTable = useBnbSelector((state) => state.finance.info.disclaimer?.table);

    const [buyDescriptionLabel, buyDescriptionMonthlyLabel] = useBnbOptionalLabel([
        "buyDescription",
        "buyDescriptionMonthly",
    ]);
    const description =
        financeOption === "monthly" && buyDescriptionMonthlyLabel
            ? "buyDescriptionMonthly"
            : buyDescriptionLabel
              ? "buyDescription"
              : null;

    const onBuyCar = (): void => {
        trackCtaCheckout(NavStep.Buy, "online-retailing-checkout");
        dispatch(buyCar());
    };
    const openConditionsModal = (event: React.MouseEvent): void => {
        event.preventDefault();
        dispatch(showModal({ type: MODAL_BUY_TERMS }));
    };

    return (
        <>
            <Styles.Wrapper hasBackground>
                <Container maxWidth={{ _: "none", lg: 750 }}>
                    <Flex.Row>
                        <Flex.Col width={{ _: 1, lg: 1 / 2 }}>
                            <Styles.Title>
                                <BnbLabel
                                    label={financeOption === "cash" ? "buyTitle" : "buyTitleMonthly"}
                                    fallbackLabel="buyTitle"
                                />
                            </Styles.Title>

                            {description && (
                                <Styles.Description>
                                    <BnbLabel label={description} useHTML />
                                </Styles.Description>
                            )}

                            <List.IconList>
                                {labels.map((item) => (
                                    <List.IconListItem key={item.icon}>
                                        {getBuyIcon(item.icon)}
                                        {item.extraInfo || item.extraText ? (
                                            <List.IconListItemText>
                                                <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                                <Popover showOnClick content={item.extraInfo} />
                                                <span dangerouslySetInnerHTML={{ __html: item.extraText || "" }} />
                                            </List.IconListItemText>
                                        ) : (
                                            <List.IconListItemText dangerouslySetInnerHTML={{ __html: item.text }} />
                                        )}
                                    </List.IconListItem>
                                ))}
                            </List.IconList>

                            {enableTermsConditions && (
                                <Button.Link onClick={openConditionsModal}>
                                    <Text.Button>
                                        <BnbLabel
                                            label={
                                                financeOption === "cash"
                                                    ? "buyTermsConditionsLink"
                                                    : "buyTermsConditionsLinkMonthly"
                                            }
                                            fallbackLabel="buyTermsConditionsLink"
                                        />
                                    </Text.Button>
                                </Button.Link>
                            )}
                        </Flex.Col>

                        <Styles.Sidebar width={{ _: 1, lg: 1 / 2 }}>
                            <PaymentPanel buyCar={onBuyCar} />
                        </Styles.Sidebar>
                    </Flex.Row>
                </Container>
            </Styles.Wrapper>

            {financeOption === "monthly" && quoteTable && quoteTable.length && (
                <Styles.Wrapper>
                    <Container py={3}>
                        <FinanceQuotes />
                    </Container>
                </Styles.Wrapper>
            )}

            <Styles.Wrapper hasBackground>
                <Container>
                    <DisclaimerContainer showGenericFinanceDisclaimer />
                </Container>
            </Styles.Wrapper>
        </>
    );
};

export default BuyView;
